(function() {
  const triggers = document.querySelectorAll('.accordion-toggle-btn');
  let activeToggle;
  triggers &&
  triggers.forEach(trigger => {
    trigger.collapseTarget = document.querySelector(trigger.dataset.toggle || trigger.dataset.target);
    trigger.collapseTarget.dataset.parent && trigger.collapseTarget.classList.contains("is-active") && (activeToggle = trigger);
    trigger.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      toggle(trigger);
    });
    // Remove height when end open transition
    trigger.collapseTarget.addEventListener("transitionend", ({ target }) => {
      if (!target.classList.contains("is-active")) return;
      target.style.height = null;
    });
  });
  function toggle(trigger) {
    if (trigger.collapseTarget.classList.contains("is-active")) {
      close(trigger);
      activeToggle = null;
    } else {
      activeToggle &&
      activeToggle.collapseTarget.dataset.parent &&
      close(activeToggle);
      trigger.collapseTarget.dataset.parent && (activeToggle = trigger);
      open(trigger);
    }
  }
  function close(trigger) {
    setHeight(trigger.collapseTarget);
    trigger.parentElement.classList.remove("is-active");
    trigger.classList.remove("is-active");
    trigger.collapseTarget.classList.remove("is-active");
    setTimeout(() => {
      trigger.collapseTarget.style.height = null;
    }, 0);
  }
  function open(trigger) {
    trigger.classList.add("is-active");
    trigger.parentElement.classList.add("is-active");
    setTimeout(() => {
      setHeight(trigger.collapseTarget);
      trigger.collapseTarget.classList.add("is-active");
    }, 0);
  }
  function setHeight(target) {
    target.style.height = target.scrollHeight + "px";
  }
  
  window.addEventListener('scroll', function() {
    const checkStickyHeader = document.querySelector('sticky-header');
    if(checkStickyHeader){
      var getHeight = document.querySelector('sticky-header').offsetHeight;
      var triggerHeading = document.querySelector('.faq-trigger__headings').style.setProperty('--sticky-header-height', `${getHeight}px`)
      
    }
  });

  const triggerButtons = document.querySelectorAll('.trigger-link');
  if(triggerButtons){
    triggerButtons.forEach(function(button) {
      button.addEventListener('click', function(event){
        event.preventDefault();
        const thisId = this.getAttribute('href');
        const findDiv = document.getElementById(thisId);
        const offsetTop = findDiv.offsetTop;
        const getHeaderHeight = document.querySelector('sticky-header').offsetHeight;
        var triggerHeadingHeight = document.querySelector('.faq-trigger__headings').offsetHeight;
        if(window.matchMedia("(max-width: 749px)").matches){
          triggerHeadingHeight = 0;
        }
        const plusHeight = parseInt(getHeaderHeight)+parseInt(triggerHeadingHeight);
        const finalScroll = offsetTop - plusHeight;
        console.log(finalScroll)
        window.scrollTo(0, finalScroll);


      });
    });
  }
})();
if(location.href.includes('?=shipping-delivery')){
  document.querySelector('[href="shipping-delivery"]').click();
}